import UpdateDeliverableForm from './UpdateDeliverableForm';

export default UpdateDeliverableForm;
